import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    whop?: {
      track: (...args: unknown[]) => void;
      setScope: (...args: unknown[]) => void;
    };
    rdt?: (...args: unknown[]) => void;
  }
}

/**
 * Fires the Whop "page" tracking event on every client-side route change so
 * SPA navigations are tracked in addition to the initial load (which is
 * handled by the inline pixel in index.html).
 */
const WhopPixel = () => {
  const { pathname } = useLocation();

  const first = useRef(true);
  useEffect(() => {
    // Initial Reddit PageVisit fires from index.html; track SPA navigations here.
    if (first.current) first.current = false;
    else window.rdt?.("track", "PageVisit");
    if (typeof window !== "undefined" && window.whop) {
      window.whop.track("page");
    }
  }, [pathname]);

  return null;
};

export default WhopPixel;
